import React, { useEffect, useState } from 'react';
import baseUrl from "../BaseUrl";

// Basic inline styles can be defined as objects for readability
const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f3f4f6', // Equivalent to bg-gray-100
    padding: '16px', // Equivalent to p-4
    boxSizing: 'border-box' // Ensure padding doesn't add to overall width
};

const cardStyle = {
    backgroundColor: '#ffffff', // Equivalent to bg-white
    padding: '32px', // Equivalent to p-8
    borderRadius: '12px', // Equivalent to rounded-xl
    boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)', // Equivalent to shadow-xl
    width: '100%', // Equivalent to w-full
    maxWidth: '600px', // INCREASED WIDTH HERE (was 448px)
    textAlign: 'center' // Equivalent to text-center
};

const headingStyle = {
    fontSize: '30px', // Equivalent to text-3xl
    fontWeight: '800', // Equivalent to font-extrabold
    color: '#1f2937', // CHANGED TO BLACK/DARK GRAY HERE (was blue-700)
    marginBottom: '24px', // Equivalent to mb-6
    display: 'flex', // ADDED FLEX FOR LOGO ALIGNMENT
    alignItems: 'center', // VERTICALLY ALIGN ITEMS
    justifyContent: 'center', // CENTER THE LOGO AND TEXT
    gap: '10px', // SPACE BETWEEN LOGO AND TEXT
};

// NEW STYLE FOR THE LOGO
const logoStyle = {
    height: '60px', // Match favicon size
    width: '140px', // Match favicon size
    marginRight: '8px', // Small margin to separate from text if gap isn't enough
};

// Styles for the static QR code image
const qrCodeImageContainerStyle = {
    marginBottom: '24px', // mb-6
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    border: '1px solid #e5e7eb', // border border-gray-200
    borderRadius: '8px', // rounded-lg
    backgroundColor: '#f9fafb', // bg-gray-50
};

const qrCodeImageStyle = {
    maxWidth: '256px', // Max size for the QR code image
    height: 'auto',
    display: 'block',
    margin: '0 auto', // Center the image
    marginBottom: '16px',
};

const qrCodeImageDescriptionStyle = {
    fontSize: '14px', // text-sm
    color: '#4b5563', // text-gray-600
    textAlign: 'center', // text-center
};

const messageTextStyle = {
    color: '#4b5563', // Equivalent to text-gray-700
    fontSize: '18px', // Equivalent to text-lg
    marginBottom: '32px' // Equivalent to mb-8
};

const buttonContainerStyle = {
    display: 'flex',
    flexDirection: 'row', // CHANGED TO ROW FOR HORIZONTAL LAYOUT
    gap: '16px', // Equivalent to space-x-4 for horizontal spacing
    alignItems: 'center',
    justifyContent: 'center', // Center the row of buttons
    flexWrap: 'wrap', // Allow wrapping on smaller screens
};

// NEW STYLES FOR THE BUTTON IMAGES
const storeImageStyle = {
    height: '60px', // Fixed height for consistency
    width: 'auto',  // Maintain aspect ratio
    borderRadius: '8px', // Slightly rounded corners for the images
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', // Shadow
    transition: 'transform 0.2s ease-in-out', // Smooth hover effect
    cursor: 'pointer',
};

const spinnerContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px', // Equivalent to space-y-4
};

const spinnerStyle = {
    animation: 'spin 1s linear infinite', // Needs @keyframes in a <style> tag or global CSS
    height: '32px', // Equivalent to h-8
    width: '32px', // Equivalent to w-8
    color: '#3b82f6', // Equivalent to text-blue-500
};


// Ensure your main CSS file (e.g., index.css) has this @keyframes for the spinner:
/*
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
*/

function AppDownload() {
    const [, setLoading] = useState(true); // True initially to show spinner
    const [message, setMessage] = useState('');
    const [playStoreUrl, setPlayStoreUrl] = useState('');
    const [appStoreUrl, setAppStoreUrl] = useState('');
    const [shouldDisplayDownloadPage, setShouldDisplayDownloadPage] = useState(false); // Controls rendering of the main content

    useEffect(() => {
        const fetchDeviceDetectionAndRedirect = async () => {
            try {
                const response = await fetch(`${baseUrl}/detect-device`); 
                const data = await response.json();
                
                console.log('API Response:', data);
 
                const fetchedPlayStoreUrl = data.playStoreUrl || 'https://play.google.com/store/apps/details?id=health.pauser.android&hl=en_IN';
                const fetchedAppStoreUrl = data.appStoreUrl || 'https://apps.apple.com/us/app/pauser-monitor-heart-stress/id6470737790';

                // Attempt immediate redirection first
                if (data.device && data.device.os) {
                    if (data.device.os.name === 'Android' && fetchedPlayStoreUrl) {
                        console.log('Client-side redirect: Detected Android OS. Redirecting to Play Store.');
                        window.location.href = fetchedPlayStoreUrl;
                        return; // IMPORTANT: Stop execution of this effect
                    } else if (data.device.os.name === 'iOS' && fetchedAppStoreUrl) {
                        console.log('Client-side redirect: Detected iOS. Redirecting to App Store.');
                        window.location.href = fetchedAppStoreUrl;
                        return; // IMPORTANT: Stop execution of this effect
                    }
                }

                // If we reach here, it means no automatic redirection occurred.
                // So, display the download page with manual options.
                console.log('Client-side: No automatic mobile OS detected for redirection. Displaying download page.');
                setMessage(data.message || 'Please choose your download option below.');
                setPlayStoreUrl(fetchedPlayStoreUrl);
                setAppStoreUrl(fetchedAppStoreUrl);
                setLoading(false); // Stop showing spinner
                setShouldDisplayDownloadPage(true); // Show the full download page
                
            } catch (error) {
                console.error('Error fetching device detection:', error);
                setMessage('Could not detect device automatically. Please use the buttons below.');
                setPlayStoreUrl('https://play.google.com/store/apps/details?id=health.pauser.android&hl=en_IN');
                setAppStoreUrl('https://apps.apple.com/us/app/pauser-monitor-heart-stress/id6470737790');
                setLoading(false); // Stop showing spinner
                setShouldDisplayDownloadPage(true); // Show the full download page on error
            }
        };
 
        fetchDeviceDetectionAndRedirect();
    }, []); // Empty dependency array ensures this runs once on mount
 
    return (
        <div style={containerStyle}>
            {/* Conditional rendering: Show spinner OR the main download page */}
            {!shouldDisplayDownloadPage ? (
                // Only show spinner if we're still determining whether to redirect or display page
                <div style={spinnerContainerStyle}>
                    <svg style={spinnerStyle} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle style={{opacity: '0.25'}} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path style={{opacity: '0.75'}} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <p style={messageTextStyle}>{message || 'Detecting your device and checking for app links...'}</p>
                </div>
            ) : (
                // Render the full download page content if shouldDisplayDownloadPage is true
                <div style={cardStyle}>
                    <h1 style={headingStyle}>
                        {/* Logo — clicking opens website */}
                        <a
                            href="https://pauser.health"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
                        >
                            <img
                                src="/Pauser-logo.png"
                                alt="App Logo"
                                style={{ ...logoStyle, cursor: 'pointer' }}
                                onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/32x32/cccccc/000000?text=Logo"; }}
                            />
                        </a>
                    </h1>
                    
                    {/* Static QR Code Image Display */}
                    <div style={qrCodeImageContainerStyle}>
                        <p>Scan this QR code to download the app:</p>
                        <img 
                            src="/pauser-download-QR.png" // Your QR code image path
                            alt="Scan to Download App" 
                            style={qrCodeImageStyle} 
                            onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/256x256/cccccc/000000?text=QR+Code+Missing"; }} // Fallback for missing image
                        />
                        <p style={qrCodeImageDescriptionStyle}>
                            (Scanning this QR code will automatically detect your device and redirect.)
                        </p>
                    </div>

                    <p style={messageTextStyle}>{message}</p>
                    <div style={buttonContainerStyle}>
                        {playStoreUrl && (
                            <a 
                                href={playStoreUrl} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                    display: 'flex', 
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textDecoration: 'none',
                                }}
                            >
                                <img 
                                    src="/google playstore image.png" // Path to your Google Play image
                                    alt="Download on Google Play" 
                                    style={storeImageStyle} 
                                    onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                    onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/180x60/cccccc/000000?text=Google+Play"; }}
                                />
                            </a>
                        )}
                        {appStoreUrl && (
                            <a 
                                href={appStoreUrl} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textDecoration: 'none',
                                }}
                            >
                                <img 
                                    src="/app store image.png" // Path to your App Store image
                                    alt="Download on the App Store" 
                                    style={storeImageStyle} 
                                    onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                    onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/180x60/cccccc/000000?text=App+Store"; }}
                                />
                            </a>
                        )}

                        {/* Website button */}
                        <a
                            href="https://pauser.health"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
                        >
                            <div
                                style={{
                                    height: '60px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px',
                                    backgroundColor: '#000000',
                                    borderRadius: '8px',
                                    padding: '0 20px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s ease-in-out',
                                    minWidth: '160px',
                                }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            >
                                {/* Globe icon */}
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="white"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    style={{ height: '28px', width: '28px', flexShrink: 0 }}
                                >
                                    <circle cx="12" cy="12" r="10" />
                                    <line x1="2" y1="12" x2="22" y2="12" />
                                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                                </svg>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <span style={{ color: '#ffffff', fontSize: '10px', fontWeight: '700', lineHeight: '1.4', letterSpacing: '0.05em'}}>Learn More on the</span>
                                    <span style={{ color: '#ffffff', fontSize: '18px', fontWeight: '700', lineHeight: '1.2', letterSpacing: '0.01em' }}>Website</span>
                                </div>
                            </div>
                        </a>
                    </div>
                    {/* <p style={smallTextStyle}>
                        If automatic redirection didn't work, click one of the images above.
                    </p> */}
                </div>
            )}
        </div>
    );
}

export default AppDownload;